module.exports = __webpack_public_path__ + "img/consult_info9.06f67512.png";